/* Der Termin einer Leistung (P10-02) — rein, ohne React, damit die Tests
   ihn direkt laden. Verwendet von `daten/merkliste.ts` und `masken/Vermieten.tsx`. */

/**
 * **Der Termin einer Leistung aus dem gefragten Zeitraum** (P10-02,
 * Durchgang 05.10.2026). In „Vermieten" gewählt, ist der Tag (oder Zeitraum)
 * auch der Tag, an dem die Leistung erbracht wird — er geht als
 * `planned_from`/`planned_until` an die Position und von dort als
 * Leistungsdatum auf AB und Rechnung. Ohne Anfang kein Termin; ohne Ende ein
 * Tag. Leer heißt: „Termin offen", wie bisher.
 */
export function leistungstermin(von: string | null | undefined, bis: string | null | undefined): { von?: string; bis?: string } {
  if (!von) return {};
  return { von, bis: bis && bis >= von ? bis : von };
}

/**
 * Der Zeitraum, den alle Mieten der Sammlung teilen — oder keiner. Eine
 * Leistung, die unter der Sammlung dazukommt („+ Leistung"), bekommt ihn als
 * Termin vorbelegt (Regel 11); bei verschiedenen Zeiträumen bleibt er offen
 * und wird im Abschluss an der Zeile gesetzt (P10-02).
 */
export function gemeinsamerZeitraum(posten: { art?: string; von: string; bis: string }[]): { von?: string; bis?: string } {
  const mieten = posten.filter((p) => (p.art ?? "miete") === "miete");
  const erste = mieten[0];
  if (!erste || !erste.von) return {};
  return mieten.every((p) => p.von === erste.von && p.bis === erste.bis)
    ? leistungstermin(erste.von, erste.bis)
    : {};
}
